"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTab = void 0;
var core_1 = require("@material-ui/core");
var polished_1 = require("polished");
var styled_components_1 = __importDefault(require("styled-components"));
exports.BaseTab = styled_components_1.default(core_1.Tab).withConfig({ displayName: "BaseTab", componentId: "sc-1vr77vi" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["color:", ";opacity:1;text-transform:none;font-size:", ";&.Mui-selected{color:", ";font-weight:600;}"], ["", "", "", ""])), function (_a) {
    var theme = _a.theme;
    return theme.vui.component.tab.default.color;
}, polished_1.rem(14), function (_a) {
    var theme = _a.theme;
    return theme.vui.component.tab.selected.color;
});
var templateObject_1;
